import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { Box, Button } from '@material-ui/core';

import { useButtonContainerStyles } from './styles';
import { REPORT_ISSUES } from '../../../../constants/Routes';
import { showReportIssue } from '../../../../constants/Visible';
import { simpleUrl } from '../../../../config/paths';
import { setSelectedProduct } from '../../../../redux/actions/ProductActions';

const ButtonContainer = ({ ...props }) => {
  const {
    isMkp,
    billImage,
    thumbnailImage,
    name,
    orderId,
    totalPrice,
    quantity,
    purchaseDate,
    sku,
    urlNc,
    source,
  } = props;
  const reduxDispatch = useDispatch();
  const classes = useButtonContainerStyles();
  const location = useLocation();

  const setProductSelected = () => reduxDispatch(setSelectedProduct(props));

  return (
    <Box display="flex" flexDirection="column">
      {!isMkp && (
        <Button
          className={classes.button}
          variant="outlined"
          color="secondary"
          onClick={() => window.open(billImage, '_blank')}
        >
          Descargar boleta
        </Button>
      )}
      <Button
        className={classes.button}
        variant="outlined"
        color="secondary"
        onClick={() =>
          window.open(`${simpleUrl}${sku}#tab-Comentarios`, '_blank')
        }
        data-cy="writeOpinionButton"
      >
        Escribir opinión
      </Button>
      {urlNc && (
        <Button
          className={classes.button}
          variant="outlined"
          color="secondary"
          disabled={!urlNc}
          onClick={() => window.open(urlNc, '_blank')}
          data-cy="downloadNCButton"
        >
          Descargar nota de crédito
        </Button>
      )}
      {showReportIssue === 'on' && (
        <Link
          to={{
            pathname: REPORT_ISSUES,
            search: `?orderId=${orderId}&sku=${sku}`,
            state: {
              mobile: false,
              product: {
                thumbnailImage,
                name,
                orderId,
                totalPrice,
                quantity,
                purchaseDate,
                source,
                sku,
              },
              prevRoute: location.pathname,
            },
          }}
          className={classes.link}
          data-cy="linkReportIssue"
        >
          <Button
            variant="outlined"
            color="secondary"
            className={`${classes.fullWidth} ${classes.button}`}
            onClick={setProductSelected}
          >
            Reportar inconveniente
          </Button>
        </Link>
      )}
    </Box>
  );
};

ButtonContainer.propTypes = {
  isMkp: PropTypes.bool,
  billImage: PropTypes.string,
  nc: PropTypes.bool,
  urlNc: PropTypes.string,
  thumbnailImage: PropTypes.string,
  name: PropTypes.string,
  orderId: PropTypes.number,
  totalPrice: PropTypes.number,
  quantity: PropTypes.number,
  purchaseDate: PropTypes.string,
  sku: PropTypes.string,
  source: PropTypes.string,
};

export default ButtonContainer;
